import apiInstance from "@services/Shared/instanceAxios";

const getAccount = (uuid: string) =>
  apiInstance({
    url: "/account/" + uuid,
  });

export default getAccount;
